export enum ELanguage {
  Amharic = 'am',
  Arabic = 'ar',
  Bengali = 'bn',
  HakhaChin = 'cn',
  German = 'de',
  English = 'en',
  Spanish = 'es',
  Farsi = 'fa',
  Falam = 'fl',
  French = 'fr',
  Greek = 'gr',
  Gujarati = 'gu',
  Hindi = 'hi',
  HaitianCreole = 'ht',
  Armenian = 'hy',
  Italian = 'it',
  Korean = 'ko',
  Marathi = 'mr',
  Burmese = 'my',
  Punjabi = 'pa',
  Polish = 'pl',
  Portuguese = 'pt',
  Russian = 'ru',
  Tagalog = 'tl',
  Ukrainian = 'uk',
  Urdu = 'ur',
  Vietnamese = 'vi',
  ChineseSimplified = 'zh',
  ZhS = 'zh-s',
  ChineseTraditional = 'zh-t',
  Tigrinya = 'ti',
  Khmer = 'km',
  Somali = 'so',
  Japanese = 'ja',
  Thai = 'th',
}
